module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Ogłoszenia")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": _vm.getRouteToAdd
    }
  }, [_vm._v("Dodaj ogłoszenie")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.notices), function(notice, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(notice.header))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(notice.date)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "to": _vm.getRouteToEdit(notice)
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('question-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "question": "Czy na pewno usunąć to ogłoszenie?"
      },
      on: {
        "click": function($event) {
          _vm.remove(notice)
        }
      }
    }, [_vm._v("\n          Usuń\n        ")])], 1)])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nagłówek")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89cd5708","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notices.vue
// module id = 462
// module chunks = 1